export const CLIENT_PORTAL_PREFIX = 'CLIENT-PORTAL-PREFIX_';

export const FETCH_ANNUAL_PLAN_RENEWAL_LIST =
CLIENT_PORTAL_PREFIX + 'FETCH_ANNUAL_PLAN_RENEWAL_LIST';